/*
 * Licensed to the Apache Software Foundation (ASF) under one or more
 * contributor license agreements.  See the NOTICE file distributed with
 * this work for additional information regarding copyright ownership.
 * The ASF licenses this file to You under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with
 * the License.  You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Export all the explicitly exported components, this file will contain our
// components when built by webpack and sent off to the world.

import ConfirmationPageButtons from './components/ConfirmationPageButtons';
import ContactUsInfo from './components/ContactUsInfo';
import EmailMobileVerification from './components/EmailMobileVerification';
import ExistingLicence from './components/ExistingLicence';
import ExistingOrganisationParty from './components/ExistingOrganisationParty';
import Footer from './components/Footer';
import InputValidation from './components/InputValidation';
import InputWithValidation from './components/InputWithValidation';
import { ListView } from './components/ListView';
import MobileWithValidation from './components/MobileWithValidation';
import OrganisationType from './components/OrganisationType';
import OrganisationWrapped from './components/OrganisationWrapped';
import OrganisationYINC from './components/OrganisationYINC';

export {
  OrganisationType,
  OrganisationYINC,
  OrganisationWrapped,
  ExistingLicence,
  ExistingOrganisationParty,
  ContactUsInfo,
  InputWithValidation,
  InputWithValidation as EmailWithValidation,
  MobileWithValidation,
  Footer,
  InputValidation,
  EmailMobileVerification,
  ListView,
  ConfirmationPageButtons,
};

export { default as FileUploadPattern } from 'components/Patterns/FileUpload/FileUpload';
export { createFileUploadApi, useFileUploadApi } from 'components/Patterns/FileUpload/FileUpload.api';

export * from './components/GelTheme';

export * from './components/Address/AutoSuggestAddress';
export * from './components/Address/OverseasAddress';
export * from './components/Address/GlobalAddress';
export * from './components/AutoSuggest';
export * from './components/ContactNumber';
export * from './components/FeeSummary';
export * from './components/Header';
export * from './components/Layout';
export * from './components/MonthYearDate';
export * from './components/NavigationButtons';
export * from './components/NextSteps';
export * from './components/Question';
export * from './components/Selection/RadioGroup';
export * from './components/Selection/RadioSelect';
export * from './components/Selection/Select';
export * from './components/SmartOrganisationSearch';
export * from './components/SummaryCard';
export * from './components/Textarea';
export * from './components/UserFeedback';
export * from './components/VerifiableContactDetailField';
export * from './components/OverseasContactNumber';

export * from './hooks';

export * from './components/Utils/toCamelCase';
export * from './components/Utils/Validation';

// Types
export * from './types/kiama';
export * from './types/types';
export type { FieldValidator } from './components/Utils/Validation.types';
export type { FileUploadProps, UploadedFile } from 'components/Patterns/FileUpload/FileUpload';
export type { FileUploadApi } from 'components/Patterns/FileUpload/FileUpload.api';
